(function (window, document) {
  window.magna = window.magna || {}
  if (window.magna.__productBoxModalDelegated) return
  window.magna.__productBoxModalDelegated = true

  window.magna.closeModal = (event, el) => {
    if (!event.target.classList.contains('overlay') && !event.target.classList.contains('modal-close')) {
      return
    }

    document.querySelectorAll('.modal').forEach((modal) => {
      modal.classList.remove('modal--open')
    })

    const overlay = document.querySelector('.overlay')
    const blurBackground = document.querySelector('.blur-background')
    if (overlay) overlay.remove()
    if (blurBackground) blurBackground.remove()
    document.body.style.overflow = 'auto'
  }

  window.magna.modal = (event) => {
    const target = event.currentTarget
    if (!target || !target.querySelector('.modal')) return

    const blurBackground = document.createElement('div')
    const overlay = document.createElement('div')
    const span = document.createElement('span')
    span.innerText = '×'
    span.classList.add('modal-close')
    blurBackground.setAttribute('class', 'blur-background')
    overlay.setAttribute('class', 'overlay')
    overlay.addEventListener('click', (clickEvent) => window.magna.closeModal(clickEvent, target))
    overlay.appendChild(span)

    document.body.prepend(blurBackground)
    document.body.prepend(overlay)

    blurBackground.classList.add('blur-background--open')
    overlay.classList.add('overlay--open')

    target.querySelector('.modal').classList.add('modal--open')
    document.body.style.overflow = 'hidden'
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-modal-trigger]')
    if (!trigger) return
    window.magna.modal({ currentTarget: trigger, target: event.target })
  })
})(window, document)
